import {useState,useEffect} from "react";
import {Link,useNavigate} from "react-router-dom";
import ImageWithBasePath from "../../../core/img";
import {all_routes} from "../../router/all_routes";
import Slider from "react-slick";
import dayjs from 'dayjs';
import Select from "react-select";
import {countrys,states} from "../../../core/common/selectOption";
import {Toaster} from 'react-hot-toast';
import {UrlQuery} from "biz9-react-utility";
import SubValue from "../../subValue";
import series from 'async/series';
// -- biz9 --
import {Page_Logic,Portal_Type,Portal_Url,Portal_Title,Sub_Value_Logic,Portal_Value_Type,Portal_Page,Portal_Remote_Page,Portal_Remote_Data,Portal_Remote_CMS,Sub_Value_Type,Portal_Table,Portal_Field,Portal_Remote_Image,Portal_Remote_User,Portal_Remote_Stat} from "biz9-portal-app";
import {Image_Format} from "biz9-image";
import {Log,Num,Str,DateTime,Status_Type,Response_Field,Obj} from "biz9-utility";
import {Type,Url,Field,Title,Message,Config} from "../../../constant";
import {Field_Logic,Image,Style,User,Toast_Message,App,Storage} from "../../../project";
import {User_Table,User_Title,User_Logic,User_Role} from "biz9-user";
import {Data_Logic} from "biz9-data-app";
import {Stat_Logic} from "biz9-stat";
type PasswordField = "password";
const Register = () => {
    /* -- DEFINE -- *
     * --- IMPORTANT ---
     *  DO NOT CACHE THIS PAGE. On logout and login get sub values which will be removed on log out.
     * --- BUTTONZ ---
     * btn_post_login - post-login
     * --- FIELD-GROUPZ ---
     * #3 thumb
     *    title
     *    sub_note
     *
     */
    const navigate = useNavigate();
    const query = UrlQuery();
    //edit-start
    const [sub_value_edit,setSubValueEdit] = useState(Sub_Value_Logic.get_sub_value_edit(Portal_Table.PAGE,0));
    const [page,setPage] = useState(Data_Logic.get(Portal_Table.PAGE,0));
    const [sub_value_group,setSubValueGroup] = useState(Sub_Value_Logic.get_test_sub_value_group({count:50,show_value:false}));
    const [edit_mode,setEditMode] = useState(false);
    //edit-end
    const [val_username,setValUserName] = useState("melrosefoxx"+Str.get_id());
    const [val_country,setValCountry] = useState(countrys.find(option => option.value === "United States"));
    const [val_state,setValState] = useState(states.find(option => option.value === "Florida"));
    const [val_city,setValCity] = useState("Miami");
    const [val_email,setValEmail] = useState('tankrose'+Str.get_id()+'@gmail.com');
    //123456789Ab!
    const [val_password,setValPassword] = useState("123456789Ab!");
    useEffect(() => {
            Toast_Message.loading(Message.LOADING);
            get_page_data();
            },[]);
    /*
       useEffect(() => {
       Toast_Message.loading(Message.LOADING);
       get_data();
       },[]);
       */
    async function get_page_data() {
        // -- get-page-data --
        let option = {get_cache:false,time_limit:10};
        const [response,data] = await Portal_Remote_Page.get(App.get_url(Portal_Url.PAGE_GET),Portal_Page.REGISTER_HOME.title_url,option);
        bind_page(data);
    };
    async function bind_page(data) {
        // -- page --
        setPage(data[Portal_Type.PAGE]);
        // -- page-edit --
        setEditMode(query.get('edit_mode'));
        setSubValueEdit(Sub_Value_Logic.get_sub_value_edit(Portal_Table.PAGE,data[Portal_Type.PAGE].id));
        // -- sub-values --
        bind_sub_values(data[Portal_Type.SUB_VALUE_GROUP]);
        Toast_Message.dismiss();
    };
    async function bind_sub_values(data_sub_group) {
        // -- bind-sub-values --
        for(const sub_group in data_sub_group){
            if(data_sub_group[sub_group].type != Sub_Value_Type.ITEMS){
                sub_value_group[Portal_Type.SUB_VALUE_UNDER_SCORE+data_sub_group[sub_group].value_id].value = data_sub_group[sub_group].value;
            }else{
                sub_value_group[Portal_Type.SUB_VALUE_UNDER_SCORE+data_sub_group[sub_group].value_id].items = data_sub_group[sub_group].items;
            }
        }
        Storage.post_sub_value_group(sub_value_edit,data_sub_group);
    };
    async function update_sub_value(sub_value) {
        // -- page-edit-sub-values --
        if(sub_value.type != Sub_Value_Type.ITEMS){
            setSubValueGroup(sub_value_group => ({
                        ...sub_value_group,
                        [Portal_Type.SUB_VALUE_UNDER_SCORE+sub_value.value_id]: {
                        ...sub_value_group[Portal_Type.SUB_VALUE_UNDER_SCORE+sub_value.value_id],
                        value: sub_value.value
                        }
                        }));
        }else{
            setSubValueGroup(sub_value_group => ({
                        ...sub_value_group,
                        [Portal_Type.SUB_VALUE_UNDER_SCORE+sub_value.value_id]: {
                        ...sub_value_group[Portal_Type.SUB_VALUE_UNDER_SCORE+sub_value.value_id],
                        items: sub_value.items
                        }
                        }));
        }
    }
    async function btn_register_post() {
        // -- post-register --
        let post_success = false;
        let user = Data_Logic.get(Portal_Table.USER,0,{data:{username:Str.get_title_url(val_username.toLowerCase()), email:val_email.toLowerCase(),password:val_password,country:val_country.value,state:val_state.value,city:val_city,role:User_Role.USER}});
        series([
                async function(call) {
                    // -- remote-data-response --
                Toast_Message.loading(Message.LOADING);
                let option = {};
                const [response,data] = await Portal_Remote_User.register(App.get_url(Portal_Url.USER_REGISTER),user,option);
                if(response[Response_Field.STATUS] == Status_Type.SUCCESS){
                post_success =  true;
                Toast_Message.success(response.message);
                Storage.post_dashboard_type_user();
                User.post(data);
                Storage.post_dashboard_apps([]);
                }else{
                Toast_Message.error(response.message);
                }
                },
                async function(call) {
                    // -- post-stat-register --
                if(post_success){
                let stat = Stat_Logic.get(user,Portal_Type.POST_REGISTER,user.id,user);
                const [response,data] = await Portal_Remote_Stat.post(App.get_url(Portal_Url.STAT_POST),stat);
                }
                },
                ], function(err, results) {
                    if(post_success){
                        navigate(all_routes.dashboard_user_home);
                    }
                });
    };
    //edit
    const updateValCountry = (selectedOption) => {
        setValCountry(selectedOption);
    };
    const updateValState = (selectedOption) => {
        setValState(selectedOption);
    };
    const updateValCity = (event) => {
        setValCity(event.target.value);
    };
    const updateUserNameValue = (event: {
target: { value: React.SetStateAction<string> };
}) => {
        setValUserName(event.target.value);
    };
const updateEmailValue = (event: {
target: { value: React.SetStateAction<string> };
}) => {
    setValEmail(event.target.value);
};
const updatePasswordValue = (event: {
target: { value: React.SetStateAction<string> };
}) => {
    setValPassword(event.target.value);
};
const loginslideroption = {
dots: true,
      nav: false,
      infinite: true,
      arrows:false,
      speed: 500,
      slidesToShow: 1,
      draggable: true,
      tochMove: true,
      slidesToScroll: 1,
      responsive: [
      {
breakpoint: 1000,
            settings: {
slidesToShow: 1,
            },
      },
      {
breakpoint: 700,
            settings: {
slidesToShow: 1,
            },
      },
      {
breakpoint: 550,
            settings: {
slidesToShow: 1,
            },
      },
      {
breakpoint: 0,
            settings: {
slidesToShow: 1,
            },
      },
      ],
};
const [passwordVisibility, setPasswordVisibility] = useState({
password: false,
});
const togglePasswordVisibility = (field: PasswordField) => {
    setPasswordVisibility((prevState) => ({
                ...prevState,
                [field]: !prevState[field],
                }));
};
const customStyles = {
option: (base: any, state: any) => ({
                ...base,
                color: "#6A7287",
                backgroundColor: state.isSelected ? "#ddd" : "white",
                cursor: "pointer",
                "&:hover": {
backgroundColor: state.isFocused ? "#FF6900" : "white",
color: state.isFocused ? "#fff" : "#6A7287",
},
}),
    };
return (
        <div>
        <>
        <Toaster />
        {/* Sign Up */}
        <div className="row gx-0">
        {/* Banner Content */}
        <div className="col-lg-6">
        <div className="authentication-wrapper">
        <div className="authentication-content">
        <div className="login-carousel ">

        {edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.ITEMS,3):""}
        <Slider {...loginslideroption}>
        {sub_value_group.sub_value_3.items.map((item) => (
                    <div className="login-slider">
                    <ImageWithBasePath
                    src={Image.get_url(item.thumb,Image_Format.ORIGINAL)}
                    className="img-fluid" alt="img" />
                    <h2>
                    {item.title}
                    </h2>
                    <p>
                    {item.sub_note}
                    </p>
                    </div>
                    ))}


        </Slider>
        </div>
        </div>
        <div className="login-bg">
        <ImageWithBasePath
        src="/assets/img/bg/shape-01.png"
        alt="img"
        className="shape-01"
        />
        <ImageWithBasePath
        src="/assets/img/bg/shape-02.png"
        alt="img"
        className="shape-02"
        />
        <ImageWithBasePath
        src="/assets/img/bg/shape-03.png"
        alt="img"
        className="shape-03"
        />
        <ImageWithBasePath
        src="/assets/img/bg/shape-04.png"
        alt="img"
        className="shape-04"
        />
        <ImageWithBasePath
        src="/assets/img/bg/shape-05.png"
        alt="img"
        className="shape-05"
        />
        <ImageWithBasePath
        src="/assets/img/bg/shape-06.png"
        alt="img"
        className="shape-06"
        />
        <ImageWithBasePath
        src="/assets/img/bg/shape-07.png"
        alt="img"
        className="shape-07"
        />
        </div>
        </div>
        </div>
{/* /Banner Content */}
<>
{/* Register Content */}
<div className="col-lg-6">
<div className="login-wrapper">
<div className="login-content">
<form>
<div className="login-userset">
<div className="login-logo">
<ImageWithBasePath src="/assets/img/logo.png" alt="img" />
</div>
<div className="login-card">
<div className="login-heading">
<h3>
{edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.TEXT,5):""}
{sub_value_group.sub_value_5.value}
</h3>
<p>

{edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.TEXT,6):""}
{sub_value_group.sub_value_6.value}
</p>
</div>

<div>
<label className="form-label">User Name</label>
<div className="form-wrap form-focus">
<span className="form-icon">
<i className="feather icon-user" />
</span>
<input type="text" className="form-control floating"  value={val_username} onChange={updateUserNameValue} />
</div>
</div>

<div>
<label className="form-label">Country</label>
<div className="form-wrap form-focus">
<span className="form-icon">
<i className="feather icon-user" />
</span>
<Select
classNamePrefix="react-select"
className="select"
styles={customStyles}
options={countrys}
value={val_country}
onChange={updateValCountry}
/>
</div>
</div>

<div>
<label className="form-label">State</label>
<div className="form-wrap form-focus">
<span className="form-icon">
<i className="feather icon-user" />
</span>
<Select
classNamePrefix="react-select"
className="select"
styles={customStyles}
options={states}
value={val_state}
onChange={updateValState}
/>
</div>
</div>

<div>
<label className="form-label">City</label>
<div className="form-wrap form-focus">
<span className="form-icon">
<i className="feather icon-user" />
</span>
<input type="text" className="form-control floating"  value={val_city} onChange={updateValCity} />
</div>
</div>

<div>
<label className="form-label">Email</label>
<div className="form-wrap form-focus">
<span className="form-icon">
<i className="feather icon-mail" />
</span>
<input value={val_email} onChange={updateEmailValue}  type="email" className="form-control floating"/>
</div>
</div>
<div>
<label className="form-label">Password</label>
<div className="form-wrap form-focus pass-group">
<span className="form-icon">
<i
className={`ti toggle-passwords ${passwordVisibility.password
    ? "ti-eye"
        : "ti-eye-off"
}`}
onClick={() =>
    togglePasswordVisibility("password")
}
></i>
</span>
<input value={val_password} onChange={updatePasswordValue}  type={ passwordVisibility.password ? "text" : "password"}
className="pass-input form-control"
/>
</div>
</div>
<div className="form-wrap">
<div className="form-check">
<input className="form-check-input" type="checkbox" defaultValue="" id="flexCheckDefault" />
<label
className="form-check-label"
htmlFor="flexCheckDefault"
>
By login you agree to our{" "}
<Link
to={"#"}
className="terms-links"
>
Terms of Use
</Link>{" "}
and{" "}
<Link
to={"#"}
className="terms-links"
>
Privacy Policy
</Link>
</label>
</div>
</div>
<Link to={"#"} onClick={() => btn_register_post()} type="submit" className="btn btn-primary">
Sign Up
</Link>
{/*
    <div className="login-or">
    <span className="span-or">or sign up with</span>
    </div>
    <ul className="login-social-link">
    <li>
    <Link to="#">
    <ImageWithBasePath
    src="/assets/img/icons/google-icon.svg"
    alt="Facebook"
    />{" "}
    Google
    </Link>
    </li>
    <li>
    <Link to="#">
    <ImageWithBasePath src="/assets/img/icons/fb.svg" alt="Google" />{" "}
    Facebook
    </Link>
    </li>
    </ul>
    */}

</div>
<div className="acc-in">
<p>
Already have an account?{" "}
<Link to={all_routes.login}>Sign In</Link>
</p>
</div>
</div>
</form>
</div>
</div>
</div>
{/* /Register Content */}
</>
</div>
{/* /Sign Up */}
</>
<SubValue sub_value_edit={sub_value_edit} edit_mode={edit_mode} update_sub_value={update_sub_value}  />
</div>
);
};

export default Register;
